import { Redirect } from 'expo-router';
import { Platform, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import JoinEonOne from '@/components/eon-one';
import EonOneMobile from '@/components/eon-one/mobile';
import EonOneTutorial from '@/components/eon-one/tutorial';
import { isDesktop, useHasOrganization } from '@/core';
import { Loader } from '@/ui/loader';

// These orgs should never see the Eon One intro tutorial, regardless of
// organization status.
const EON_ONE_TUTORIAL_BLOCKED_ORG_SLUGS = ['joulez', 'reslacom', 'resla'];

export default function JoinEonOneScreen() {
  useStyles();

  const isNative = Platform.OS !== 'web';
  const { organization, canUseEonOne, isPending } = useHasOrganization();

  if (isNative || !isDesktop()) {
    return <EonOneMobile />;
  }

  if (isPending) {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loader style={{ height: 250, width: 250 }} />
      </View>
    );
  }

  if (canUseEonOne) {
    return <Redirect href="/partner/eon-one/settings" />;
  }

  if (
    organization &&
    !EON_ONE_TUTORIAL_BLOCKED_ORG_SLUGS.includes(organization.urlSlug)
  ) {
    return <EonOneTutorial />;
  }

  return <JoinEonOne />;
}
